/* GridColumnComponent.js */

"use strict";

const EventEmitter = require('events').EventEmitter;
const Renderer = require("./GridColumnRenderer");
const DefaultColumnRendererComponent = require("../column_renderer/default/DefaultColumnComponent");
const _ = require('lodash');

class GridColumnComponent extends EventEmitter {

    constructor(configOptions) {
        super();

        this._id = _.get(configOptions, 'id', undefined);
        this._width = _.get(configOptions, 'width', undefined);
        this._showHeader = _.get(configOptions, 'showHeader', true);
        this._label = _.get(configOptions, 'label', '');
        this._sortable = _.get(configOptions, 'sortable', false);
        this._sort = _.get(configOptions, 'sort', '');
        this._columnRendererComponent = _.get(configOptions, 'columnRendererComponent', DefaultColumnRendererComponent);
        this._entityColumn = _.get(configOptions, 'entityColumn', false);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._id = undefined;
            this._width = undefined;
            this._showHeader = undefined;
            this._label = undefined;
            this._sortable = undefined;
            this._sort = undefined;
            this._columnRendererComponent = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    _triggerUserSorted(event){
        this.emit('UserSorted', this._sort, event);
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    setId(newVal){
        this._id = newVal;
        this.emit('ID', this._id);
        return this;
    }
    getId(){
        return this._id;
    }

    setWidth(newVal){
        this._width = newVal;
        this.emit('Width', this._width);
        return this;
    }
    getWidth(){
        return this._width;
    }

    setShowHeader(newVal){
        this._showHeader = newVal;
        this.emit('ShowHeader', this._showHeader);
        return this;
    }
    getShowHeader(){
        return this._showHeader;
    }

    setLabel(newVal){
        this._label = newVal;
        this.emit('Label', this._label);
        return this;
    }
    getLabel(){
        return this._label;
    }

    setSortable(newVal){
        this._sortable = newVal;
        this.emit('Sortable', this._sortable);
        return this;
    }
    getSortable(){
        return this._sortable;
    }

    setSort(newVal){
        this._sort = newVal;
        this.emit('Sort', this._sort);
        return this;
    }
    getSort(){
        return this._sort;
    }

    setColumnRendererComponent(newVal){
        this._columnRendererComponent = newVal;
        this.emit('ColumnRendererComponent', this._columnRendererComponent);
        return this;
    }
    getColumnRendererComponent(){
        return this._columnRendererComponent;
    }

    setEntityColumn(newVal){
        this._entityColumn = newVal;
        return this;
    }
    getEntityColumn(){
        return this._entityColumn;
    }
    
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = GridColumnComponent;